/**
 * Tous les javascripts sont inclus dans ce fichier, cela inclus
 * les plugins et autres scripts.
 */
require('@webcomponents/webcomponentsjs');
require('./polyfill');

require('../../../assets/global/scripts/app_new');
require('../../../assets/global/scripts/custom');